import { useGetCreditsAmountTypeOnActionPopup } from '@aibees/elephant/hooks/use-get-credits-amount-type-on-action-popup';
import { classnames } from '@aibees/shared/utils';
import { AlertTitle, Stack, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportWarningTotalProps as Props } from './types';

export const ExportWarningTotal = memo(({ className }: Props) => {
  const { basicPeople } = useGetCreditsAmountTypeOnActionPopup();

  const shouldShow = useMemo(() => {
    return basicPeople;
  }, [basicPeople]);

  if (!shouldShow) return null;
  return (
    <Styled.Wrapper
      className={classnames('ExportWarningTotal', className)}
      sx={SX.root}
      severity="default"
      variant="outlined"
    >
      <AlertTitle sx={{ fontSize: '14px', fontWeight: 'bold' }}>
        Important – Export pulls from Saved Records
      </AlertTitle>
      <Stack>
        <Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Go to the Saved Records tab and select contact you’ll export.
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Open Enrich{' '}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Update Job Changes,{' '}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Update Profile Insights{' '}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Run Email Enrichment & Re-Verification.
            </Typography>
          </Stack>
        </Stack>
        <Typography variant="body4" fontWeight={400} color="grey.600" mt={2}>
          Skipping steps may lead to exporting outdated company or profile data.
        </Typography>
      </Stack>
    </Styled.Wrapper>
  );
});

ExportWarningTotal.displayName = 'ExportWarningTotal';
